import { HttpError } from '@/errors/HttpError';
import { hashtagCampaignService } from './hashtagCampaignService';
import type { HashtagCampaignCatalogItem } from '@/types/hashtag.types';
import { mergeHashtagCampaigns } from '@/utils/hashtagCampaignCatalog';
import {
  loadHashtagCampaignsFromSession,
  saveHashtagCampaignsToSession,
} from '@/utils/hashtagCampaignSession';

function isCampaignListUnavailable(err: unknown): boolean {
  if (!(err instanceof HttpError)) return false;
  const status = err.response?.status;
  return status === 404 || status === 405 || status === 501;
}

/** Catálogo para admin y filtros dashboard (GET BFF + caché sesión si falla). */
export const hashtagCatalogService = {
  getCampaigns: async (_tenantCode: string): Promise<HashtagCampaignCatalogItem[]> => {
    const fromSession = loadHashtagCampaignsFromSession();

    try {
      const fromApi = await hashtagCampaignService.list();
      const merged = mergeHashtagCampaigns([...fromApi, ...fromSession]);
      if (merged.length > 0) {
        saveHashtagCampaignsToSession(merged);
      }
      return merged;
    } catch (err: unknown) {
      if (isCampaignListUnavailable(err)) {
        return mergeHashtagCampaigns(fromSession);
      }
      throw err;
    }
  },
};
